import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import moment from 'moment'
import 'moment/locale/fr'

import fr from '../locales/fr_FR.json'
import nl from '../locales/nl_NL.json'
import de from '../locales/de_DE.json'

import sharedFr from '../../shared/locales/fr_FR.json'
import sharedNl from '../../shared/locales/nl_NL.json'
import sharedDe from '../../shared/locales/de_DE.json'

import sharedShopFr from '../../shared/locales/fr_FR.shop.json'
import sharedShopNl from '../../shared/locales/nl_NL.shop.json'
import sharedShopDe from '../../shared/locales/de_DE.shop.json'

moment.locale('fr')

export const options = [
  { value: 'fr', label: 'lang_option_French' },
  { value: 'nl', label: 'lang_option_Dutch' },
  { value: 'de', label: 'lang_option_German' }
]

export const initi18n = () => {
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      debug: false,
      defaultNS: 'translations',
      detection: {
        lookupQuerystring: 'lng',
        order: ['querystring', 'localStorage']
      },
      fallbackLng: 'fr',
      interpolation: {
        escapeValue: false,
        formatSeparator: ','
      },
      ns: ['translations'],
      react: {
        wait: true
      },
      resources: {
        fr: { ...fr, ...sharedFr, ...sharedShopFr },
        nl: { ...nl, ...sharedNl, ...sharedShopNl },
        de: { ...de, ...sharedDe, ...sharedShopDe }
      }
    })
  return i18n
}
